'use strict';
import angular from 'angular';

angular.module('inventorycalendar.services', [])
    .service('InventoryCalendarService', InventoryCalendarService)
    .service('InventoryCalendarFactory', InventoryCalendarFactory);

InventoryCalendarService.$inject = ['InventoryCalendarFactory', '$q'];
function InventoryCalendarService (InventoryCalendarFactory, $q) {
    //service object
    var service = {};

    //declare your server vars here
    service.slots = null;
    service.available = null;
    service.errors = null;
    service.adSizes = null;
    service.websitePlacements = null;
    service.websiteSections = null;

    service.getSlotsForWebsiteAndSection = function(websiteId, sectionId) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': sectionId
        };

        InventoryCalendarFactory.getSlotsForWebsiteAndSection().get(params).$promise.then(function(data) {
            if (data.slots == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.areAllSlotsAvailableForWebsiteAndSectionAndDate = function(websiteId, sectionId, bookingDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'bookingDate': bookingDate
        };

        InventoryCalendarFactory.areAllSlotsAvailableForWebsiteAndSectionAndDate().get(params).$promise.then(function(data) {
            service.data = data.available ? true : false;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.areAllSlotsAvailableForWebsiteAndSectionAndPeriod = function(websiteId, sectionId, startDate, endDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'startDate': startDate,
            'endDate': endDate
        };

        InventoryCalendarFactory.areAllSlotsAvailableForWebsiteAndSectionAndPeriod().get(params).$promise.then(function(data) {
            service.data = data.available ? true : false;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.areAllSlotsAvailableForWebsiteAndDate = function(websiteId, bookingDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'bookingDate': bookingDate
        };

        InventoryCalendarFactory.areAllSlotsAvailableForWebsiteAndDate().get(params).$promise.then(function(data) {
            service.data = data.available ? true : false;
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getSlotBookings = function() {
        var deferred = $q.defer();
        var params = {};

        InventoryCalendarFactory.getSlotBookings().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBookedSlotsForWebsite = function(websiteId) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId
        };

        InventoryCalendarFactory.getBookedSlotsForWebsite().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBookedSlotsForWebsiteAndDate = function(websiteId, bookingDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': bookingDate
        };

        InventoryCalendarFactory.getBookedSlotsForWebsiteAndDate().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBookedSlotsForWebsiteAndPeriod = function(websiteId, startDate, endDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'startDate': startDate,
            'endDate': endDate
        };

        InventoryCalendarFactory.getBookedSlotsForWebsiteAndPeriod().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.bookedSlotsForWebsitesAndSections = function(websiteId, sectionId) {
        var deferred = $q.defer();
        var params = {
            'websiteIds[]': websiteId,
            'sectionIds[]': sectionId
        };

        InventoryCalendarFactory.bookedSlotsForWebsitesAndSections().get(params).$promise.then(function(data) {
            if (data.slot_bookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slot_bookings;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.bookedSlotsForWebsiteAndSectionAndAdSize = function(websiteId, sectionId, adSizeId) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'adSizeId': adSizeId
        };

        InventoryCalendarFactory.bookedSlotsForWebsiteAndSectionAndAdSize().get(params).$promise.then(function(data) {
            if (data.slot_bookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slot_bookings;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.bookedSlotsForWebsitesAndSectionsAndSlotTypes = function(websiteIds, sectionIds, slotTypeIds) {
        var deferred = $q.defer();
        var params = {
            'websiteIds[]': websiteIds,
            'sectionIds[]': sectionIds,
            'slotTypeIds[]': slotTypeIds
        };

        InventoryCalendarFactory.bookedSlotsForWebsitesAndSectionsAndSlotTypes().get(params).$promise.then(function(data) {
            if (data.slot_bookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slot_bookings;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBookedSlotsForWebsiteAndSectionAndDate = function(websiteId, sectionId, bookingDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'bookingDate': bookingDate
        };

        InventoryCalendarFactory.getBookedSlotsForWebsiteAndSectionAndDate().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getAdSizes = function(clusterId) {
        var deferred = $q.defer();
        var params = {
            'clusterId': clusterId
        };

        InventoryCalendarFactory.getAdSizes().get(params).$promise.then(function(data) {
            if (data.adSizes == null) {
                service.adSizes = [];
            } else {
                service.adSizes = data.adSizes;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getWebsitePlacements = function(clusterId) {
        var deferred = $q.defer();
        var params = {
            'clusterId': clusterId
        };

        InventoryCalendarFactory.getWebsitePlacements().get(params).$promise.then(function(data) {
            if (data.websitePlacements == null) {
                service.websitePlacements = [];
            } else {
                service.websitePlacements = data.websitePlacements;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWebsiteSections = function(propertyName) {
        var deferred = $q.defer();
        var params = {
            'parentContentValue': propertyName
        };

        InventoryCalendarFactory.getWebsiteSections().get(params).$promise.then(function(data) {
            if (data.websiteSections == null) {
                service.websiteSections = [];
            } else {
                service.websiteSections = data.websiteSections;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getSlotTypes = function() {
        var deferred = $q.defer();

        InventoryCalendarFactory.getSlotTypes().get().$promise.then(function(data) {
            if (data.slotTypes == null) {
                service.slotTypes = [];
            } else {
                service.slotTypes = data.slotTypes;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBookedSlotsForWebsiteAndSectionAndPeriod = function(websiteId, sectionId, startDate, endDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'startDate': startDate,
            'endDate': endDate
        };

        InventoryCalendarFactory.getBookedSlotsForWebsiteAndSectionAndPeriod().get(params).$promise.then(function(data) {
            if (data.slotBookings == null) {
                service.slots = [];
            } else {
                service.slots = data.slots;
            }
            deferred.resolve();
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getAvailableSlotsForWebsiteAndSectionsAndPeriod = function(websiteId, sectionIds, slotTypeIds, startDate, endDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionIds[]': sectionIds,
            'slotTypeIds[]': slotTypeIds,
            'startDate': startDate,
            'endDate': endDate
        };

        InventoryCalendarFactory.getAvailableSlotsForWebsiteAndSectionsAndPeriod().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getBookedSlotsForWebsiteAndSectionsAndPeriod = function(websiteId, sectionIds, slotTypeIds, startDate, endDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionIds[]': sectionIds,
            'slotTypeIds[]': slotTypeIds,
            'startDate': startDate,
            'endDate': endDate
        };

        InventoryCalendarFactory.getBookedSlotsForWebsiteAndSectionsAndPeriod().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.reservedSlotsForWebsiteAndSectionsAndPeriod = function(websiteId, sectionIds, slotTypeIds, startDate, endDate) {
        var deferred = $q.defer();
        var params = {
            'websiteId': websiteId,
            'sectionIds[]': sectionIds,
            'slotTypeIds[]': slotTypeIds,
            'startDate': startDate,
            'endDate': endDate
        };

        InventoryCalendarFactory.reservedSlotsForWebsiteAndSectionsAndPeriod().get(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addSlotReservation = function(slotId, reservationDate, clientId) {
        var deferred = $q.defer();
        var params = {
            'slotId': slotId,
            'reservationDate': reservationDate
        };
        if(clientId) {
            params.clientId = clientId;
        }

        InventoryCalendarFactory.slotReservation().post(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteSlotReservation = function(slotId, reservationDate) {
        var deferred = $q.defer();
        var params = {
            'slotId': slotId,
            'reservationDate': reservationDate
        };

        InventoryCalendarFactory.slotReservation().delete(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            deferred.reject();
        });

        return deferred.promise;
    };

    return service;
}

InventoryCalendarFactory.$inject = ['$resource', 'AppConfig'];
function InventoryCalendarFactory($resource, AppConfig) {
    var factory = {};

    factory.getAdSizes = function(clusterId) {
        return $resource(AppConfig.IO_API_URL + 'lookups/adSizes', {
            'clusterId': clusterId
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getWebsitePlacements = function(clusterId) {
        return $resource(AppConfig.IO_API_URL + 'lookups/websitePlacements', {
            'clusterId': clusterId
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getWebsiteSections = function(clusterId) {
        return $resource(AppConfig.IO_API_URL + 'lookups/websiteSections', {
            'clusterId': clusterId
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSlotTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'slots/slotTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSlotsForWebsiteAndSection = function(websiteId, sectionId) {
        return $resource(AppConfig.IO_API_URL + 'getSlotsForWebsiteAndSection', {
            'websiteId': websiteId,
            'sectionId': sectionId
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.areAllSlotsAvailableForWebsiteAndSectionAndDate = function(websiteId, sectionId, bookingDate) {
        return $resource(AppConfig.IO_API_URL + 'areAllSlotsAvailableForWebsiteAndSectionAndDate', {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'bookingDate': bookingDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.areAllSlotsAvailableForWebsiteAndSectionAndPeriod = function(websiteId, sectionId, startDate, endDate) {
        return $resource(AppConfig.IO_API_URL + 'areAllSlotsAvailableForWebsiteAndSectionAndPeriod', {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'startId': startDate,
            'endId': endDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.areAllSlotsAvailableForWebsiteAndDate = function(websiteId, bookingDate) {
        return $resource(AppConfig.IO_API_URL + 'areAllSlotsAvailableForWebsiteAndDate', {
            'websiteId': websiteId,
            'bookingDate': bookingDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getSlotBookings = function() {
        return $resource(AppConfig.IO_API_URL + 'getSlotBookings', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBookedSlotsForWebsite = function(websiteId) {
        return $resource(AppConfig.IO_API_URL + 'getBookedSlotsForWebsite', {
            'websiteId': websiteId
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBookedSlotsForWebsiteAndDate = function(websiteId, bookingDate) {
        return $resource(AppConfig.IO_API_URL + 'getBookedSlotsForWebsiteAndDate', {
            'websiteId': websiteId,
            'bookingDate': bookingDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBookedSlotsForWebsiteAndPeriod = function(websiteId, startDate, endDate) {
        return $resource(AppConfig.IO_API_URL + 'getBookedSlotsForWebsiteAndPeriod', {
            'websiteId': websiteId,
            'startDate': startDate,
            'endDate': endDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.bookedSlotsForWebsitesAndSections = function() {
        return $resource(AppConfig.IO_API_URL + 'slots/bookedSlotsForWebsitesAndSections', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.bookedSlotsForWebsiteAndSectionAndAdSize = function(websiteId, sectionId, adSizeId) {
        return $resource(AppConfig.IO_API_URL + 'slots/bookedSlotsForWebsiteAndSectionAndAdSize', {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'adSizeId': adSizeId
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.bookedSlotsForWebsitesAndSectionsAndSlotTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'slots/bookedSlotsForWebsitesAndSectionsAndSlotTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBookedSlotsForWebsiteAndSectionAndDate = function(websiteId, sectionId, bookingDate) {
        return $resource(AppConfig.IO_API_URL + 'getBookedSlotsForWebsiteAndSectionAndDate', {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'bookingDate': bookingDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBookedSlotsForWebsiteAndSectionAndPeriod = function(websiteId, sectionId, startDate, endDate) {
        return $resource(AppConfig.IO_API_URL + 'getBookedSlotsForWebsiteAndSectionAndPeriod', {
            'websiteId': websiteId,
            'sectionId': sectionId,
            'startDate': startDate,
            'endDate': endDate
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getAvailableSlotsForWebsiteAndSectionsAndPeriod = function(params) {
        return $resource(AppConfig.IO_API_URL + 'slots/availableSlotsForWebsiteAndSectionsAndPeriod', params, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getBookedSlotsForWebsiteAndSectionsAndPeriod = function(params) {
        return $resource(AppConfig.IO_API_URL + 'slots/bookedSlotsForWebsiteAndSectionsAndPeriod', params, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.reservedSlotsForWebsiteAndSectionsAndPeriod = function(params) {
        return $resource(AppConfig.IO_API_URL + 'slots/reservedSlotsForWebsiteAndSectionsAndPeriod', params, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.slotReservation = function(params) {
        return $resource(AppConfig.IO_API_URL + 'slots/slotReservation', params, {
            'post': {
                method: 'POST',
                isArray: false
            },
            'delete': {
                method: 'DELETE',
                isArray: false
            }
        });
    };

    return factory;

}